import { Stack } from 'expo-router'
import { FC } from 'react'

const Layout: FC = () => {
    return (
        <Stack screenOptions={{ headerShown: false }}>
            <Stack.Screen name="[uuid]" />
        </Stack>
    )
}

export default Layout
